import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ecommerceBaseUrl } from "network";

export const shopCatSlice = createApi({
    reducerPath: "shopCatSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: ecommerceBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getShopCategories: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/category?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addShopCategory: builder.mutation({
            query: (body) => ({
                url: "/category",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateShopCategory: builder.mutation({
            query: ({ id, body }) => ({
                url: `/category/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteShopCategory: builder.mutation({
            query: (id) => ({
                url: `/category/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetShopCategoriesQuery,
    useAddShopCategoryMutation,
    useUpdateShopCategoryMutation,
    useDeleteShopCategoryMutation
} = shopCatSlice;
